import {Link, Text, VStack} from 'platform/foundation';
import styled from 'styled-components';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {TestDriveCalendarVehicle} from '@dms/api/sales';
import {vehiclesRoutes} from '@dms/routes';

import {composePath, EMPTY_PLACEHOLDER, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CALENDAR_LAYOUT} from '../constants/CALENDAR_LAYOUT';

interface TestDriveVehicleColumnProps extends RequiredTestIdProps {
  vehicle: TestDriveCalendarVehicle;
  rowHeight: number;
}

const StickyCell = styled.div<{$rowHeight: number}>`
  position: sticky;
  left: 0;
  z-index: ${CALENDAR_LAYOUT.STICKY_COLUMN_Z_INDEX};
  box-sizing: border-box;
  /* Declared by the calendar's Scroller, which narrows it on a phone. */
  width: var(--test-drive-vehicle-column-width);
  min-width: var(--test-drive-vehicle-column-width);
  height: ${(props) => props.$rowHeight}px;
  padding: ${CALENDAR_LAYOUT.VEHICLE_CELL_PADDING}px 8px;
  /*
   * The row cannot grow to its content, so anything the three lines cannot fit is cut here
   * rather than left to bleed over the row below.
   */
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.general.white};
  border-right: 1px solid ${(props) => props.theme.colors.general.separator};
  border-bottom: 1px solid ${(props) => props.theme.colors.general.separator};
`;

const TitleClamp = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export function TestDriveVehicleColumn(props: TestDriveVehicleColumnProps) {
  return (
    <StickyCell $rowHeight={props.rowHeight}>
      <VStack>
        <TitleClamp title={props.vehicle.title}>
          <Link
            data-testid={suffixTestId('vehicleTitle', props)}
            size="small"
            title={props.vehicle.title}
            noWrap
            href={composePath(vehiclesRoutes.detail, {
              params: {id: props.vehicle.vehicleId},
              isSearchParamsPreserved: false,
            })}
          />
        </TitleClamp>
        <Text size="xSmall" color="secondary" noWrap>
          {isNotNilOrEmpty(props.vehicle.registrationPlate)
            ? props.vehicle.registrationPlate
            : EMPTY_PLACEHOLDER}
        </Text>
        <Text size="xSmall" color="tertiary" noWrap>
          {props.vehicle.branchName}
        </Text>
      </VStack>
    </StickyCell>
  );
}
